import { render, staticRenderFns } from "./MittelFormular.vue?vue&type=template&id=6ac0e819"
import script from "./MittelFormular.vue?vue&type=script&lang=js"
export * from "./MittelFormular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports